import { Navigate } from 'react-router-dom';
import { useAuth } from '../../contexts/AuthContext';
import { hasRole, hasAnyRole } from '../../services/auth';

export const RequireRole = ({ children, roles, redirectTo }) => {
  const { user, loading } = useAuth();

  if (loading) {
    return (
      <div className="flex items-center justify-center min-h-screen bg-gradient-to-br from-emerald-50/20 via-white to-green-50/10">
        <div className="animate-spin rounded-full h-12 w-12 border-2 border-emerald-600 border-t-transparent"></div>
      </div>
    );
  }

  if (!user) {
    return <Navigate to="/login" replace />;
  }

  // Check if user has required role(s)
  const hasRequiredRole = Array.isArray(roles)
    ? hasAnyRole(user, roles)
    : hasRole(user, roles);

  if (!hasRequiredRole) {
    // Redirect based on user's role
    if (hasRole(user, 'client')) {
      return <Navigate to="/client/home" replace />;
    }
    if (hasRole(user, 'host')) {
      // Redirect hosts to the host app (gathur-landing)
      const hostAppUrl = process.env.REACT_APP_HOST_APP_URL || 'https://host.gathur.travel';
      window.location.href = `${hostAppUrl}/host/dashboard`;
      return null;
    }
    if (hasRole(user, 'admin')) {
      return <Navigate to="/admin" replace />;
    }
    return <Navigate to={redirectTo || '/login'} replace />;
  }

  return <>{children}</>;
};
